module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-384-min.b3cf5607.jpg";